export default "__VITE_ASSET__CyjLb0NR__"